/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Component, OnInit } from "@angular/core";
import { Store, select } from "@ngrx/store";
import { UserState } from "src/app/state/user-state";
import { Observable } from "rxjs";
import { selectUserBalanceInMBC } from "src/app/state/reducer/user.reducer";
import { ICONS } from "src/app/core/constants/icons";
import { ROUTES } from "src/app/core/constants/routes";
import { HeaderService } from "src/app/core/services/header.service";
import { Location } from "@angular/common";
import { NavigationEnd, Router } from "@angular/router";
import { DialogService } from "src/app/core/services/dialog.service";

@Component({
  selector: "app-status-bar",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"]
})

export class HeaderComponent implements OnInit {

  protected $mbcBalance: Observable<number | undefined> = this.store.pipe(select(selectUserBalanceInMBC));
  protected ARROW_LEFT_WHITE = ICONS.ARROW_LEFT_WHITE;
  protected INFO_WHITE = ICONS.INFO_WHITE;
  protected LOGO = ICONS.LOGO;
  protected MBC_FRONT_SIDE = ICONS.MBC_FRONT_SIDE;

  constructor(private store: Store<UserState>,
    protected headerService: HeaderService,
    private location: Location,
    private router: Router,
    private dialogService: DialogService) {

    this.headerService.setCurrentNavBar();
  }

  ngOnInit(): void {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.headerService.setCurrentNavBar();
      }
    });
  }

  openInfoModal() {
    this.dialogService.openConfirmation("", this.headerService.currentNavBar!.infoMessage, false);
  }

  navigateBack() {
    this.location.back();
  }

  navigateToHome() {
    this.router.navigate([ROUTES.BETTING_TASKS]);
  }
}
